module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-backoffice-parking-slots"
  }, [_vm._m(0), _c('div', {
    staticClass: "cards"
  }, [_c('div', {
    staticClass: "help-text text-center"
  }, [_vm._v("With OWFF mode, it can happen that vehicle slots are on the same parking slot because one has a started reservation and the other is physically on the parking slot")]), _c('div', {
    staticClass: "grouped"
  }, _vm._l((_vm.slots), function(parkingSlot) {
    return _c('div', {
      staticClass: "parking-slot callout"
    }, [(parkingSlot.placeholder) ? _c('div', {
      staticClass: "placeholder"
    }, [_c('a', {
      staticClass: "fa fa-plus fa-3x",
      on: {
        "click": _vm.addParkingLot
      }
    })]) : (parkingSlot.vehicle_slots.length === 0) ? _c('div', {
      staticClass: "empty"
    }, [_c('strong', [_vm._v("PS-" + _vm._s(parkingSlot.id))]), _c('add-vehicle-asset', {
      attrs: {
        "item": parkingSlot
      },
      on: {
        "addVehicleAsset": _vm.loadSlots
      }
    }), _c('div', {
      staticClass: "slot"
    }, [_c('div', {
      staticClass: "button-group small"
    }, [_c('ArchiveVehicleSlots', {
      on: {
        "slotForArchiveSelected": function($event) {
          return _vm.archiveParkingSlot($event, parkingSlot)
        }
      }
    }), _c('button', {
      staticClass: "button alert small",
      on: {
        "click": function($event) {
          return _vm.deleteParkingSlot(parkingSlot)
        }
      }
    }, [_vm._v("Delete Slot")])], 1)])], 1) : _vm._l((parkingSlot.vehicle_slots), function(slot) {
      return _c('div', {
        staticClass: "parking-slots"
      }, [_c('h3', [_vm._v("PS" + _vm._s(parkingSlot.id))]), _c('Vehicle', {
        attrs: {
          "item": slot.vehicle,
          "type": "search-result"
        }
      }, [_c('h4', [_vm._v("VS" + _vm._s(slot.id) + " - " + _vm._s(slot.reservation_type))])]), _c('asset-management-action-buttons', {
        attrs: {
          "item": slot
        },
        on: {
          "assetMoved": _vm.loadSlots,
          "vehicleSlotDismissed": _vm.loadSlots
        }
      })], 1)
    })], 2)
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Parking lot Management")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f167853!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ParkingLotsManage.vue
// module id = 2141
// module chunks = 1